// extracted by mini-css-extract-plugin
module.exports = {"InstagramButton":"InstagramButton_InstagramButton__1C-KE","Link":"InstagramButton_Link__11dNA"};